export const CARD_HOVER_ROOT = '[data-card-hover-root]';

export const cardHoverRootProps = { 'data-card-hover-root': '' } as const;
